import { createSelector } from '@reduxjs/toolkit';

import { CHECKED_ROWS_ACTION_BAR_BOTTOM, SNACKBAR_ACTION_BAR_GAP } from '../../layoutConstants';
import { RootState } from '../slices';

/** `bottom` for the snackbar stack to clear the action bar, or null when the bar is hidden or entirely to its right */
export const getSnackbarClearanceForActionBar = createSelector(
  [
    (state: RootState) => state.application.checkedRowsActionBarRect,
    (state: RootState) => state.application.snackbarStackRight,
  ],
  (barRect, snackbarStackRight) => {
    if (barRect === null || snackbarStackRight === null) return null;
    if (barRect.left >= snackbarStackRight + SNACKBAR_ACTION_BAR_GAP) return null;

    return CHECKED_ROWS_ACTION_BAR_BOTTOM + barRect.height + SNACKBAR_ACTION_BAR_GAP;
  },
);
